import javascript from "../assets/img/javascript.png";
import react from "../assets/img/react.png";
import Node from "../assets/img/nodejs.png";
import php from "../assets/img/php.png";
import Jquery from "../assets/img/jquery.png";
import Laravel from "../assets/img/php-elephant.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/png-clipart-line-grain-decoration (1).png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Stack</h2>
              <p>
                As a multidisciplinary professional, I've
                mastered web development, content creation, and cybersecurity,<br></br>
                seamlessly blending technology, communication, and security to
                exceed expectations.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={javascript} alt="Image" />
                  <h5>Javascript</h5>
                </div>
                <div className="item">
                  <img src={react} alt="Image" />
                  <h5>React-js</h5>
                </div>
                <div className="item">
                  <img src={Node} alt="Image" />
                  <h5>Node js</h5>
                </div>
                <div className="item">
                  <img src={php} alt="Image" />
                  <h5>Php</h5>
                </div>
                <div className="item">
                  <img src={Laravel} alt="Image" />
                  <h5>Laravel</h5>
                </div>
                <div className="item">
                  <img src={Jquery} alt="Image" />
                  <h5>Jquery</h5>
                </div>
                <div className="item">
                  <img src={php} alt="Image" />
                  <h5>Tailwind</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
